import Scene3d from "./Scene3d";

// Modules

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
import { CopyShader } from 'three/examples/jsm/shaders/CopyShader.js'
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js'

export default class Scene3dFXAA extends Scene3d{

    constructor(...args){
        super(...args)


        // finally disable overloads
        if(this.parameters.disableScene3dFXAA){
            this.animate = super.animate
            this.init = super.init
            this.onWindowResize = super.onWindowResize
        }
    }

    animate(){
        this.raf = requestAnimationFrame(() => this.animate())
        this.onRender()
        this.composer1.render()
    }

    /** Init */
    
    init(){
        super.init()
        this.initPostProcessing()
    }

    initPostProcessing(){
        // post process
        this.renderer.autoClear = false
        this.renderPass = new RenderPass(this.scene, this.camera)

        this.fxaaPass = new ShaderPass(FXAAShader)

        let pixelRatio = this.renderer.getPixelRatio()

        this.fxaaPass.material.uniforms[ 'resolution' ].value.x = 1 / ( this.container.offsetWidth * pixelRatio )
        this.fxaaPass.material.uniforms[ 'resolution' ].value.y = 1 / ( this.container.offsetHeight * pixelRatio )

        this.composer1 = new EffectComposer( this.renderer )
        this.composer1.addPass( this.renderPass )
        this.composer1.addPass( this.fxaaPass )

        //

        this.copyPass = new ShaderPass( CopyShader )

        this.composer2 = new EffectComposer( this.renderer )
        this.composer2.addPass( this.renderPass )
        this.composer2.addPass( this.copyPass )
    }

    onWindowResize(){
        super.onWindowResize()
        
        // post process
        this.composer1.setSize( this.container.offsetWidth, this.container.offsetHeight )
        this.composer2.setSize( this.container.offsetWidth, this.container.offsetHeight )

        var pixelRatio = this.renderer.getPixelRatio()

        this.fxaaPass.material.uniforms[ 'resolution' ].value.x = 1 / ( this.container.offsetWidth * pixelRatio )
        this.fxaaPass.material.uniforms[ 'resolution' ].value.y = 1 / ( this.container.offsetHeight * pixelRatio )
    }
}